<template>
  <v-dialog v-model="productActivityDialog" width="500">
    <v-card>
      <v-card-title class="text-h5 white--text third">
        <span class="d-flex justify-left flex-grow-1">Sélectionnez Un Produit / Activité</span>
        <v-icon size="28" color="white" class="justify-end" @click="closeModal">mdi-close</v-icon>
      </v-card-title>

      <v-card-text class="mt-2">
        <v-autocomplete
          v-model="selectedProduct"
          class="black--text justify-left"
          label="Sélectionnez un produit"
          :items="nonSelectedProducts"
          :item-value="selectItem.value"
          :item-text="selectItem.label"
          :return-object="true"
          color="third"
        />
        <v-autocomplete
          v-model="selectedActivity"
          class="black--text justify-left"
          label="Sélectionnez Une Activité"
          :items="Productactivities"
          :item-value="selectItem.value"
          :item-text="selectItem.label"
          :return-object="true"
          color="third"
          :disabled="!selectedProduct"
        />
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="white"
          :outlined="true"
          :large="true"
          rounded
          :class="[
            'font-weight-bold my-3 text-center',
            (isReadyToSend ? 'green' : 'grey lighten-2')
          ]"
          :disabled="!isReadyToSend"
          @click="addProductActivity"
        >
          <v-icon size="24" right class="mx-0 px-4">mdi-plus-circle-outline</v-icon>
          add
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed, watch, inject, ref } from '@vue/composition-api';

import store from '@/store';

export default {
  setup () {
    const products = computed(() => store.state.products);

    const newSession = inject('newSession');
    const selectedProduct = ref('');
    const selectedActivity = ref('');
    const productActivityDialog = inject('productActivityDialog');

    const selectItem = ref({
      value: 'uuid',
      label: 'wtitle'
    });

    watch(selectedProduct, () => {
      if (!selectedProduct.value) {
        selectedActivity.value = null;
      }
    });

    const isReadyToSend = computed(() => (selectedActivity.value && selectedProduct.value));

    const nonSelectedProducts = computed(() => products.value.filter(product => {
      const filter = newSession.value.product_activity.filter(prod => prod.product === product.uuid);

      if (!filter.length) {
        return product;
      }
      if (filter.length === product.activities.length) {
        return null;
      }
      return product;
    }));

    const Productactivities = computed(() => {
      if (selectedProduct.value) {
        return (selectedProduct.value.activities || []).filter(activity => !newSession.value.product_activity.find(productActivity => productActivity.product === selectedProduct.value.value && productActivity.activity === activity.uuid)).map(activity => ({
          wtitle: activity.activity_name,
          uuid: activity.uuid
        }));
      }

      return [];
    });

    const closeModal = () => {
      selectedActivity.value = null;
      selectedProduct.value = null;
      productActivityDialog.value = false;
    };

    const addProductActivity = () => {
      newSession.value.product_activity.push({
        product: selectedProduct.value.uuid,
        activity: selectedActivity.value.uuid
      });
      closeModal();
    };

    return { selectItem, nonSelectedProducts, Productactivities, isReadyToSend, productActivityDialog, closeModal, addProductActivity, selectedProduct, selectedActivity };
  }

};

</script>
